import { Pipe, PipeTransform } from '@angular/core';
import {
  Assessment,
  BbsData,
  BbtData,
  CustomData,
  FgaData,
  NhptData,
  SingleNumberDataSet,
  SubTestDataSet,
  TugData,
} from '../services/model';

@Pipe({
  name: 'assessmentScore',
  standalone: true,
})
export class AssessmentScorePipe implements PipeTransform {
  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#ff0000a8' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#f5363975' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: 'orange' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#cdb832bd' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];

  transform(assessment: Assessment, side: 'left' | 'right' | 'none' = 'none'): string | number {
    if (assessment.type === 'ARAT') {
      let score = assessment.score;
      if (side === 'left') {
        score = assessment.score_left;
      }
      if (side === 'right') {
        score = assessment.score_right;
      }
      return score ?? -1 > -1 ? score + ' Pkt. ' : -1;
    } else if (assessment.type === 'CUSTOM') {
      const data = assessment.data as CustomData;

      let score = -1;
      if (side === 'left' || side === 'none') {
        score = data.custom.data[0].valueLeft ?? -1;
      }
      if (side === 'right') {
        score = data.custom.data[0].valueRight ?? -1;
      }
      return score ?? -1 > -1 ? score + ' %' : -1;
    } else if (assessment.type === 'BBT') {
      const data = assessment.data as BbtData;

      let score = -1;
      if (side === 'left') {
        score = data.bbt.data[0].valueLeft ?? -1;
      }
      if (side === 'right') {
        score = data.bbt.data[0].valueRight ?? -1;
      }
      return score > -1 ? score + ' Bl. ' : 'keine Testung';
    } else if (assessment.type === 'BBS') {
      const data = assessment.data as BbsData;
      let score = 0;
      data.bbs.data.forEach(subSubTest => (score += subSubTest.value ?? 0));
      return score + ' Pkt. ';
    } else if (assessment.type === 'FGA') {
      const data = assessment.data as FgaData;
      let score = 0;
      data.fga.data.forEach(subSubTest => (score += subSubTest.value ?? 0));
      return score + ' Pkt. ';

      // } else if (assessment.type === 'TS') {
      //   const data = assessment.data as TsData;
      //   const score = this.getScore(data.ts.score);
      //   return score > -1 ? score : -1;
      // } else if (assessment.type === 'TUG') {
      //   const data = assessment.data as TugData;
      //   const score = this.getScore(data.tug.score);
      //   return score > -1 ? score : -1;
      // } else if (assessment.type === 'FR') {
      //   const data = assessment.data as FrData;
      //   const score = this.getScore(data.fr.score);
      //   return score > -1 ? score : -1;
      // } else if (assessment.type === 'MWT6') {
      //   const data = assessment.data as Mwt6Data;
      //   const score = this.getScore(data.mwt6.score);
      //   return score > -1 ? score : -1;
    } else if (assessment.type === 'TUG') {
      const data = assessment.data as TugData;
      const subTest: SubTestDataSet<SingleNumberDataSet> = data.tug;
      let score = -1;
      if (side === 'left' || side === 'none') {
        score = subTest.data[0].value ?? -1;
      }
      return score ?? -1 > -1 ? score + ' s' : -1;
    } else if (assessment.type === 'NHPT') {
      const data = assessment.data as NhptData;
      let score = -1;
      if (side === 'left') {
        score = data.nhpt.data[0].valueLeft ?? -1;
      }
      if (side === 'right') {
        score = data.nhpt.data[0].valueRight ?? -1;
      }
      return score ?? -1 > -1 ? score + ' s' : -1;
    } else {
      return 0;
    }
  }

  hasValue(value: any): boolean {
    return value !== undefined && value !== null;
  }

  getScore(score: number | null | undefined): number {
    // umrechnung auf erfüllung statt Schädigung
    if (this.getPercent(score) < 0) {
      return -1;
    }
    return 100 - this.getPercent(score);

    // ehemals: icfScore zurückggeben...
    // return this.getIcf(this.getPercent(score));
  }

  getPercent(score: number | null | undefined): number {
    if (score !== undefined && score !== null && score > -1) {
      if (score <= 1 && score >= 0) {
        return Math.round(score * 100);
      } else {
        return -2;
      }
    } else {
      return -1;
    }
  }
  getIcf(score: number | null | undefined): number {
    if (score !== undefined && score !== null) {
      if (score === -2) {
        return -2;
      } else if (score === -1) {
        return -1;
      } else {
        for (const level of this.damageLevels) {
          if (score >= level.min && score <= level.max) {
            return level.icf;
          }
        }
      }

      return -1;
    } else {
      return -1;
    }
  }
}
